import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

import { TimeslotsProvider } from '../providers/timeslots-provider';
import { Observable } from "rxjs";
import { Timeslot } from "../../common/models/timeslot";

@Injectable({
  providedIn: 'root'
})
export class TimeslotResolver implements Resolve<Timeslot> {
    constructor(
        private timeslotProvider: TimeslotsProvider,
    ) { }

    public resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> {
        return this.timeslotProvider.get(+route.params['timeslotId']);
    }
}
